
  <svelte:head>
    <script defer async
    src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCURKE7KmRqlqYLftAjFgVWEOtKxKd1-xQ"
    on:load={initMap}>
    </script>

  </svelte:head>


<script>
	let container;
	let map;
	let zoom = 8;
  let center = {lat: -34.397, lng: 150.644};
    
  import { onMount } from 'svelte';
  
	// onMount(async () => {
	// 	map = new google.maps.Map(container, {
  //           zoom,
	// 		center,
	// 	});
  // });
  
    function initMap(){
      map = new google.maps.Map(container, {
              zoom,
        center,
      });
    }



</script>
<style>
.full-screen {
    width: 100vw;
    height: 100vh;
}
</style> 

<div class="full-screen" bind:this={container}></div>